import { Direction } from "./direction";

export enum PlayerCommand {
	MOVE_N = "MOVE_N",
	MOVE_NE = "MOVE_NE",
	MOVE_E = "MOVE_E",
	MOVE_SE = "MOVE_SE",
	MOVE_S = "MOVE_S",
	MOVE_SW = "MOVE_SW",
	MOVE_W = "MOVE_W",
	MOVE_NW = "MOVE_NW",

	SHOOT_N = "SHOOT_N",
	SHOOT_NE = "SHOOT_NE",
	SHOOT_E = "SHOOT_E",
	SHOOT_SE = "SHOOT_SE",
	SHOOT_S = "SHOOT_S",
	SHOOT_SW = "SHOOT_SW",
	SHOOT_W = "SHOOT_W",
	SHOOT_NW = "SHOOT_NW",

	WAIT = "WAIT",
	INTERACT = "INTERACT",
	USE_ITEM = "USE_ITEM",
	AUTO_SHOOT = "AUTO_SHOOT",
}

const moveDirections: Partial<Record<PlayerCommand, Direction>> = {
	[PlayerCommand.MOVE_N]: Direction.N,
	[PlayerCommand.MOVE_NE]: Direction.NE,
	[PlayerCommand.MOVE_E]: Direction.E,
	[PlayerCommand.MOVE_SE]: Direction.SE,
	[PlayerCommand.MOVE_S]: Direction.S,
	[PlayerCommand.MOVE_SW]: Direction.SW,
	[PlayerCommand.MOVE_W]: Direction.W,
	[PlayerCommand.MOVE_NW]: Direction.NW,
};

const shootDirections: Partial<Record<PlayerCommand, Direction>> = {
	[PlayerCommand.SHOOT_N]: Direction.N,
	[PlayerCommand.SHOOT_NE]: Direction.NE,
	[PlayerCommand.SHOOT_E]: Direction.E,
	[PlayerCommand.SHOOT_SE]: Direction.SE,
	[PlayerCommand.SHOOT_S]: Direction.S,
	[PlayerCommand.SHOOT_SW]: Direction.SW,
	[PlayerCommand.SHOOT_W]: Direction.W,
	[PlayerCommand.SHOOT_NW]: Direction.NW,
};

export function getMoveDirection(cmd: PlayerCommand): Direction | null {
	return moveDirections[cmd] ?? null;
}

export function getShootDirection(cmd: PlayerCommand): Direction | null {
	return shootDirections[cmd] ?? null;
}

const shootCommands: Record<Direction, PlayerCommand> = {
	[Direction.N]: PlayerCommand.SHOOT_N,
	[Direction.NE]: PlayerCommand.SHOOT_NE,
	[Direction.E]: PlayerCommand.SHOOT_E,
	[Direction.SE]: PlayerCommand.SHOOT_SE,
	[Direction.S]: PlayerCommand.SHOOT_S,
	[Direction.SW]: PlayerCommand.SHOOT_SW,
	[Direction.W]: PlayerCommand.SHOOT_W,
	[Direction.NW]: PlayerCommand.SHOOT_NW,
};

export function getShootCommandForDirection(dir: Direction): PlayerCommand {
	return shootCommands[dir];
}

const moveCommands: Record<Direction, PlayerCommand> = {
	[Direction.N]: PlayerCommand.MOVE_N,
	[Direction.NE]: PlayerCommand.MOVE_NE,
	[Direction.E]: PlayerCommand.MOVE_E,
	[Direction.SE]: PlayerCommand.MOVE_SE,
	[Direction.S]: PlayerCommand.MOVE_S,
	[Direction.SW]: PlayerCommand.MOVE_SW,
	[Direction.W]: PlayerCommand.MOVE_W,
	[Direction.NW]: PlayerCommand.MOVE_NW,
};

export function getMoveCommandForDirection(dir: Direction): PlayerCommand {
	return moveCommands[dir];
}
